var request = require('../request');
var base64url = require('base64url');
var raygun = require('../raygun');

var includesArray = [
    'auth',
    'registration'
];
  
var checkURL = function () {
    return includesArray.some(function (i) { return location.pathname.includes(i); });
};

function details() {
    if (checkURL() && window.navigator) {
        var date = new Date();
        var GMT = date.getTimezoneOffset()
         //convert numbers to be from GMT difference
        if (GMT < 0) {
            //Countries ahead of GMT return a minus number, this is the time GMT is behind them
            //Minus to plus
            GMT = Math.abs(GMT)
        } else {
            //Countries behind GMT return a plus number, this is the time GMT is ahead of them
            //Plus to minus
            GMT = GMT * -1
        }
        var data = JSON.stringify({ 'lang': navigator.language, 'rt': GMT, 'plf':(navigator.platform)? navigator.platform:'', 'touch':navigator.maxTouchPoints })
        //obfuscate JSON
        var eData = base64url(data)
        eData = base64url.toBase64(eData)
        // make sure we have data to send
        if (eData && eData.length > 0) {
            request.post('/en/accountmanagement/bd?ajaxmode=true', eData, 'json')
                .catch(function (err) {
                    raygun.sendError(err, 'details');
                throw(err)
              })
        }
    }
}

function init() {
    var runCheck = document.querySelector('[data-check]');
    if (runCheck) {
        details()
    }
}

document.addEventListener('DOMContentLoaded', init)